import React from "react";
import "./src/css/tailwind.css";

export const wrapRootElement = ({ element }) => (
	<div className="bg-black overflow-x-hidden overflow-y-hidden w-[100%]">
		{element}
	</div>
);
